var map = {
	"./": 18305,
	"./App": 8021,
	"./App.css": 93508,
	"./App.js": 8021,
	"./Assets/1 1.png": 46396,
	"./Assets/5.png": 72640,
	"./Assets/59945-success-confetti.gif": 87818,
	"./Assets/9MOBILE.png": 12907,
	"./Assets/AIRTEL.png": 28441,
	"./Assets/Adobe.png": 94133,
	"./Assets/Airbnb.png": 82114,
	"./Assets/Allura Online Searching.png": 6803,
	"./Assets/Amazon.png": 37156,
	"./Assets/Analythics.png": 31066,
	"./Assets/ArrowLeft.png": 87067,
	"./Assets/ArrowRight.png": 14345,
	"./Assets/Arrows4.png": 57164,
	"./Assets/Canva.png": 60676,
	"./Assets/Contact-Us-(1).png": 20013,
	"./Assets/Contact_Us.png": 33934,
	"./Assets/Demo.png": 54686,
	"./Assets/Ellipse 10.png": 25560,
	"./Assets/Ellipseleft.png": 83850,
	"./Assets/Ellipseright.png": 3626,
	"./Assets/Expedia.png": 97136,
	"./Assets/Facebook.png": 52650,
	"./Assets/Finance.png": 84433,
	"./Assets/Frame 5 (1).png": 22697,
	"./Assets/Frame 5 (2).png": 97495,
	"./Assets/Frame 5 (3).png": 11810,
	"./Assets/Frame 5 (4).png": 63909,
	"./Assets/Frame 5.png": 48164,
	"./Assets/Frame33.png": 35725,
	"./Assets/Frame44.png": 52345,
	"./Assets/Frame55.png": 42317,
	"./Assets/Frame66.png": 49505,
	"./Assets/Frame77.png": 37657,
	"./Assets/FrameOne.png": 32880,
	"./Assets/FrameTwo.png": 92362,
	"./Assets/Fresh Folk Teamwork.png": 27234,
	"./Assets/GLO.png": 69365,
	"./Assets/Grammaly.png": 76158,
	"./Assets/Group (3).png": 19603,
	"./Assets/Group (4).png": 57782,
	"./Assets/Group (5).png": 92686,
	"./Assets/Group 1 (1).png": 26090,
	"./Assets/Group 42903.png": 20866,
	"./Assets/Group 42924.png": 63555,
	"./Assets/HFfacebook.png": 60233,
	"./Assets/HFlinkedin.png": 2485,
	"./Assets/HFmessenger.png": 57652,
	"./Assets/HFtwitter.png": 43895,
	"./Assets/HThirteenArrow.png": 9092,
	"./Assets/HThirteenChart.png": 6518,
	"./Assets/HThirteenEllipse4.png": 34087,
	"./Assets/HThirteenFrame74.png": 78399,
	"./Assets/HThirteenGroup.png": 42683,
	"./Assets/HThirteenGroup42945.png": 20356,
	"./Assets/HThirteenGroup43024.png": 24319,
	"./Assets/HThirteenGroup6.png": 56143,
	"./Assets/HThirteenGroup8.png": 33085,
	"./Assets/HThirteenIcon.png": 55560,
	"./Assets/HThirteenVector.png": 84022,
	"./Assets/HThirteenbg.png": 97669,
	"./Assets/Hands Give.png": 46242,
	"./Assets/HeightBlurHero.png": 25982,
	"./Assets/HeightGroup.png": 58015,
	"./Assets/HeightHero.png": 21578,
	"./Assets/HeightStar.png": 87831,
	"./Assets/HeightTImage.png": 47477,
	"./Assets/Heightarrow.png": 78418,
	"./Assets/Heightarrowcircleup.png": 53307,
	"./Assets/HeightfIcon.png": 9144,
	"./Assets/HeightiPhone12.png": 56390,
	"./Assets/Heighticon1.png": 2424,
	"./Assets/Heighticon2.png": 91248,
	"./Assets/Heighticon3.png": 21429,
	"./Assets/Heighticon4.png": 95480,
	"./Assets/Heighticon5.png": 82274,
	"./Assets/Heighticon6.png": 34301,
	"./Assets/Heightquotedown.png": 66462,
	"./Assets/Heleven1.png": 86054,
	"./Assets/Heleven10.png": 67942,
	"./Assets/Heleven11.png": 30241,
	"./Assets/Heleven13.png": 43142,
	"./Assets/Heleven14.png": 63662,
	"./Assets/Heleven15.png": 84540,
	"./Assets/Heleven16.png": 80393,
	"./Assets/Heleven17.png": 13522,
	"./Assets/Heleven2.png": 27190,
	"./Assets/Heleven3.png": 3637,
	"./Assets/Heleven4.png": 7242,
	"./Assets/Heleven5.png": 6990,
	"./Assets/Heleven6.png": 68662,
	"./Assets/Heleven66.png": 37444,
	"./Assets/Heleven7.png": 85995,
	"./Assets/Heleven8.png": 21945,
	"./Assets/Heleven9.png": 85870,
	"./Assets/HelevenAirtime.png": 37204,
	"./Assets/HelevenFacebook.png": 50602,
	"./Assets/HelevenHero.png": 73529,
	"./Assets/HelevenInstagram.png": 85477,
	"./Assets/HelevenVector copy.png": 52177,
	"./Assets/HelevenVector.png": 35882,
	"./Assets/Helevencon.png": 74543,
	"./Assets/Helevenpas.png": 16853,
	"./Assets/Helevenpas2.png": 23015,
	"./Assets/Helevenpas4.png": 83081,
	"./Assets/Heleventwitter.png": 29122,
	"./Assets/HnineFrame4.png": 9754,
	"./Assets/HnineGroup2.png": 23527,
	"./Assets/HnineGroup4.png": 27125,
	"./Assets/HnineGroup42.png": 85892,
	"./Assets/HnineGroup66.png": 94023,
	"./Assets/HnineGroupface.png": 10976,
	"./Assets/HnineGroupinsta.png": 59089,
	"./Assets/HnineGrouptwit.png": 89490,
	"./Assets/HnineLine79.png": 60464,
	"./Assets/HnineVector.png": 80171,
	"./Assets/Hninequotedown.png": 49727,
	"./Assets/Hninequoteup.png": 49365,
	"./Assets/Hninescrolleft.png": 5158,
	"./Assets/Hninescrollright.png": 87186,
	"./Assets/Hninetestim.jpeg": 17617,
	"./Assets/Hokmefifteenglo.png": 1958,
	"./Assets/HomeFifHero.png": 95665,
	"./Assets/HomeFifteentHero.png": 73758,
	"./Assets/HomeFourAvatar.png": 96945,
	"./Assets/HomeFourHarr.png": 50679,
	"./Assets/HomeFourImg.png": 27824,
	"./Assets/HomeFourRect.png": 31756,
	"./Assets/HomeSevenHerroBg.png": 74881,
	"./Assets/HomeSixteenGooglePlay.png": 84160,
	"./Assets/HomeSixteenLogo.png": 19652,
	"./Assets/HomeSixteenMockupImageOne.png": 44586,
	"./Assets/HomeSixteenMockupImageThree.png": 30257,
	"./Assets/HomeSixteenMockupImageTwo.png": 82024,
	"./Assets/HomeSixteenOptimizeImage.jfif": 3169,
	"./Assets/Homefif9mobile.png": 96937,
	"./Assets/Homefifteenairtel.png": 63098,
	"./Assets/Homefifteenmtn.png": 56379,
	"./Assets/HomefiveArrow.png": 99682,
	"./Assets/HomefiveFrame.png": 60500,
	"./Assets/HomefiveHerroImg.png": 66550,
	"./Assets/HomefiveLine.png": 36005,
	"./Assets/HomefiveTestimg.png": 67765,
	"./Assets/HomefiveTimg.png": 25562,
	"./Assets/Homeonelogo.png": 89800,
	"./Assets/HoneArrow.png": 33566,
	"./Assets/HoneArrow2.png": 20599,
	"./Assets/HoneFirstcad.png": 60170,
	"./Assets/HoneHerro.png": 69586,
	"./Assets/HsevenArr.png": 268,
	"./Assets/HsevenFacebook.png": 67672,
	"./Assets/HsevenFooter.jpg": 95684,
	"./Assets/HsevenFooterLine.png": 84144,
	"./Assets/HsevenInstagram.png": 64318,
	"./Assets/HsevenLeftarrow.png": 19502,
	"./Assets/HsevenLine.png": 35721,
	"./Assets/HsevenRatting.png": 79092,
	"./Assets/HsevenRightarrow.png": 89128,
	"./Assets/HsevenTline.png": 24927,
	"./Assets/HsevenTwiter.png": 73836,
	"./Assets/HsevenWoman.png": 77791,
	"./Assets/Hsevenicon.png": 55481,
	"./Assets/HsevenredArrow.png": 86140,
	"./Assets/Hseventestyfour.jpg": 67425,
	"./Assets/Hseventestyone.jpg": 14925,
	"./Assets/Hseventestythree.jpg": 95489,
	"./Assets/Hseventestytwo.jpg": 73647,
	"./Assets/HsixArrow.png": 33115,
	"./Assets/HsixArrow1.png": 98871,
	"./Assets/HsixAvatar.png": 53996,
	"./Assets/HsixFrame.png": 76593,
	"./Assets/HsixFrame2.png": 66191,
	"./Assets/HsixGroup1.png": 68876,
	"./Assets/HsixGroup2.png": 28226,
	"./Assets/HsixHero.png": 47249,
	"./Assets/HsixIcon1.png": 53812,
	"./Assets/HsixLine.png": 53575,
	"./Assets/HsixLine7.png": 82083,
	"./Assets/HsixRating.png": 47962,
	"./Assets/HsixRectangle.png": 96149,
	"./Assets/HsixRectangle1.png": 94593,
	"./Assets/HsixRectangle2.png": 31965,
	"./Assets/HsixRectangle3.png": 50403,
	"./Assets/HsixRectangle4.png": 43019,
	"./Assets/HsixRectangle5.png": 21924,
	"./Assets/HsixRectangle6.png": 35164,
	"./Assets/HsixSmiling.png": 51806,
	"./Assets/Hsixicon2.png": 52384,
	"./Assets/HtenHero.png": 23886,
	"./Assets/HtwelveAvatar.png": 37533,
	"./Assets/HtwelveT.png": 72070,
	"./Assets/HtwelveTechac.png": 46207,
	"./Assets/HtwelveVector2.png": 33418,
	"./Assets/Htwelvecool.png": 90069,
	"./Assets/Htwelvedown.png": 9578,
	"./Assets/Htwelveic.png": 34749,
	"./Assets/Htwelveic2.png": 1361,
	"./Assets/Htwelveline.png": 29278,
	"./Assets/Htwelveline2.png": 31267,
	"./Assets/Htwelveuser.png": 57473,
	"./Assets/Htwelvewi.png": 60602,
	"./Assets/Htwelve“.png": 75104,
	"./Assets/HwLogo.png": 4675,
	"./Assets/Icon1.png": 2861,
	"./Assets/Icon2.png": 98686,
	"./Assets/Increase.png": 10610,
	"./Assets/Interestrate.png": 60451,
	"./Assets/LeftBorder.png": 32864,
	"./Assets/Linkedin.png": 24582,
	"./Assets/MOAVOXPAY.png": 39646,
	"./Assets/MTN.png": 79310,
	"./Assets/Messenger.png": 15250,
	"./Assets/Money.png": 37068,
	"./Assets/Netflix.png": 36551,
	"./Assets/Olá Playing Video Games.png": 57493,
	"./Assets/Other 09.png": 58488,
	"./Assets/Other 17.png": 56082,
	"./Assets/Rectangle 373.png": 97606,
	"./Assets/RectangleT.png": 82549,
	"./Assets/Rectangle_373.png": 63915,
	"./Assets/Rectangles1.png": 25454,
	"./Assets/Saly-13@2x.png": 71318,
	"./Assets/Saly-21.png": 46914,
	"./Assets/Saly-22.png": 18598,
	"./Assets/Saly-24.png": 85853,
	"./Assets/Saly-25.png": 7293,
	"./Assets/Saly-26 (1).png": 9617,
	"./Assets/Saly-26.png": 44451,
	"./Assets/Saly-31.png": 51664,
	"./Assets/Saly-42.png": 63236,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Black.otf": 35179,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-BlackItalic.otf": 82996,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Bold.otf": 30902,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-BoldItalic.otf": 734,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Italic.otf": 35632,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Light.otf": 59616,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-LightItalic.otf": 82484,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Medium.otf": 5433,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-MediumItalic.otf": 79146,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Regular.otf": 54239,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/Variable/Satoshi-Variable.ttf": 22618,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/Variable/Satoshi-VariableItalic.ttf": 29706,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/README.md": 51639,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/css/satoshi.css": 922,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.eot": 23509,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.ttf": 31711,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.woff": 70941,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.woff2": 59837,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.eot": 14882,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.ttf": 13507,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.woff": 75046,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.woff2": 29470,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.eot": 54175,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.ttf": 25740,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.woff": 83169,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.woff2": 7362,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.eot": 85291,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.ttf": 81596,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.woff": 67975,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.woff2": 3926,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.eot": 86821,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.ttf": 5561,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.woff": 13470,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.woff2": 70655,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.eot": 48353,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.ttf": 74454,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.woff": 43221,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.woff2": 38642,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.eot": 29126,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.ttf": 90778,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.woff": 62618,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.woff2": 31818,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.eot": 40271,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.ttf": 19417,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.woff": 26996,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.woff2": 3464,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.eot": 43409,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.ttf": 88958,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.woff": 38985,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.woff2": 21416,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.eot": 60297,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.ttf": 81642,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.woff": 20907,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.woff2": 3685,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.eot": 8049,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.ttf": 72651,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.woff": 40412,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.woff2": 53254,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.eot": 3847,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.ttf": 93131,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.woff": 56651,
	"./Assets/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.woff2": 67467,
	"./Assets/Satoshi_Complete/Satoshi_Complete/License/FFL.txt": 49632,
	"./Assets/Shield.png": 24988,
	"./Assets/Stuck at Home Mailing List.png": 78406,
	"./Assets/Support.png": 46354,
	"./Assets/TEllipse.png": 41798,
	"./Assets/TFrame.png": 72454,
	"./Assets/Tag.png": 22767,
	"./Assets/Tranc1.png": 14026,
	"./Assets/Tranc2.png": 5253,
	"./Assets/Tranc3.png": 47504,
	"./Assets/Trance4.png": 62641,
	"./Assets/Twitter.png": 8106,
	"./Assets/V12Line.png": 16267,
	"./Assets/Vector4.png": 50285,
	"./Assets/aboutimg.png": 61585,
	"./Assets/airtimeimg.png": 36587,
	"./Assets/amico.png": 84343,
	"./Assets/avatar3.png": 87169,
	"./Assets/brand-dark.png": 37690,
	"./Assets/brand-white.png": 65703,
	"./Assets/dataomg.png": 22985,
	"./Assets/dean-logo.png": 34669,
	"./Assets/educationimg.png": 37168,
	"./Assets/empty.png": 2158,
	"./Assets/faceimg.svg": 19264,
	"./Assets/footeromg.png": 93991,
	"./Assets/get-started.png": 19696,
	"./Assets/google.svg": 28489,
	"./Assets/grad-bg.png": 88330,
	"./Assets/heightLogo.png": 2157,
	"./Assets/hero-img-1.png": 67317,
	"./Assets/hero-img-2.png": 47916,
	"./Assets/hime-three-benefit.png": 83830,
	"./Assets/home-one-about-us.png": 82246,
	"./Assets/home-one-feature.png": 68038,
	"./Assets/home-one-hero.png": 62961,
	"./Assets/home-three-cta.png": 6394,
	"./Assets/home-three-customer.png": 33750,
	"./Assets/home-three-header-bg.png": 71184,
	"./Assets/home-three-hero.png": 32187,
	"./Assets/home-three-serv1.png": 12779,
	"./Assets/home-three-serv2.png": 79575,
	"./Assets/home-two-bg.png": 52690,
	"./Assets/home-two-feature.png": 52127,
	"./Assets/home-two-hero.png": 9673,
	"./Assets/hometwentyarror.png": 57130,
	"./Assets/homnineteenhero.png": 81253,
	"./Assets/htwentyhero.png": 93575,
	"./Assets/ico-1.png": 48218,
	"./Assets/ico-2.png": 12339,
	"./Assets/ico-3.png": 59079,
	"./Assets/ico-4.png": 67298,
	"./Assets/ico-5.png": 49607,
	"./Assets/ico-6.png": 9473,
	"./Assets/icon33.png": 52205,
	"./Assets/icon44.png": 44490,
	"./Assets/icon55.png": 25774,
	"./Assets/icon66.png": 59058,
	"./Assets/icon77.png": 58158,
	"./Assets/icons8-cancel.gif": 49099,
	"./Assets/img/benefits-bg.png": 4959,
	"./Assets/img/benefits-hero.png": 60384,
	"./Assets/img/customer.png": 31592,
	"./Assets/img/deal-hero.png": 29777,
	"./Assets/img/footer-bg.jpeg": 93031,
	"./Assets/img/footer-bg.png": 40953,
	"./Assets/img/hero.png": 43660,
	"./Assets/img/ico-1.png": 53148,
	"./Assets/img/ico-2.png": 80726,
	"./Assets/img/ico-3.png": 12715,
	"./Assets/img/ico-4.png": 71710,
	"./Assets/img/ico-5.png": 39267,
	"./Assets/img/ico-6.png": 80686,
	"./Assets/img/icon-1.png": 27122,
	"./Assets/img/icon-2.png": 73238,
	"./Assets/img/icon3.png": 72677,
	"./Assets/instaimg.png": 25456,
	"./Assets/ios.svg": 96494,
	"./Assets/kemtech_header_img.png": 97971,
	"./Assets/logo.png": 42354,
	"./Assets/man-in-office.jfif": 32711,
	"./Assets/map.png": 57644,
	"./Assets/orderimg.png": 88582,
	"./Assets/original-e0e275874b52009a537484d7785b9fa0 1.png": 72858,
	"./Assets/playstore.png": 32728,
	"./Assets/rate.png": 47268,
	"./Assets/sansation/Sansation_1.31_ReadMe.txt": 11647,
	"./Assets/sansation/Sansation_Bold.ttf": 76160,
	"./Assets/sansation/Sansation_Bold_Italic.ttf": 2807,
	"./Assets/sansation/Sansation_Italic.ttf": 5794,
	"./Assets/sansation/Sansation_Light.ttf": 36465,
	"./Assets/sansation/Sansation_Light_Italic.ttf": 29051,
	"./Assets/sansation/Sansation_Regular.ttf": 42862,
	"./Assets/sansation/Sansation_plate.jpg": 85303,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Black.otf": 73690,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-BlackItalic.otf": 68789,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Bold.otf": 29006,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-BoldItalic.otf": 77296,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Italic.otf": 68481,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Light.otf": 91137,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-LightItalic.otf": 94986,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Medium.otf": 34393,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-MediumItalic.otf": 964,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Regular.otf": 62608,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/Variable/Satoshi-Variable.ttf": 81198,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/Variable/Satoshi-VariableItalic.ttf": 97859,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/README.md": 60754,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/css/satoshi.css": 85444,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.eot": 14358,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.ttf": 15030,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.woff": 19621,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.woff2": 923,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.eot": 74770,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.ttf": 59978,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.woff": 24747,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.woff2": 45003,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.eot": 40061,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.ttf": 30751,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.woff": 74271,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.woff2": 39700,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.eot": 78894,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.ttf": 28316,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.woff": 69610,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.woff2": 25168,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.eot": 98079,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.ttf": 50930,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.woff": 90903,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.woff2": 1435,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.eot": 19751,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.ttf": 29291,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.woff": 94743,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.woff2": 82892,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.eot": 30582,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.ttf": 90585,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.woff": 40608,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.woff2": 51549,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.eot": 90573,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.ttf": 92921,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.woff": 97028,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.woff2": 31113,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.eot": 84294,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.ttf": 19506,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.woff": 89313,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.woff2": 22805,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.eot": 77497,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.ttf": 43677,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.woff": 82788,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.woff2": 93696,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.eot": 25670,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.ttf": 61998,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.woff": 97202,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.woff2": 26590,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.eot": 97649,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.ttf": 22831,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.woff": 34258,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.woff2": 63076,
	"./Assets/sansation/Satoshi_Complete/Satoshi_Complete/License/FFL.txt": 93501,
	"./Assets/services-two.png": 19995,
	"./Assets/testimg.png": 70256,
	"./Assets/testimony-img-1.png": 98747,
	"./Assets/tvimg.png": 9386,
	"./Assets/twentyonearrow.png": 20746,
	"./Assets/twentytimage.png": 54480,
	"./Assets/twiterimg.svg": 344,
	"./Assets/usertest.png": 66536,
	"./Assets/v12Group.png": 95339,
	"./Assets/v12Group2.png": 95371,
	"./Assets/v12Group3.png": 78333,
	"./Assets/v12Group4.png": 93902,
	"./Assets/v12Group5.png": 40495,
	"./Assets/v12Group6.png": 48281,
	"./Assets/v12Heroing.png": 83056,
	"./Assets/v12Icon.png": 85300,
	"./Assets/v12Line8.png": 27491,
	"./Assets/v12check.png": 18244,
	"./Assets/v12facebook.png": 20542,
	"./Assets/v12instagram.png": 38981,
	"./Assets/v12paylogo.png": 21222,
	"./Assets/v12phoneimg.png": 40269,
	"./Assets/v12whiteIcon.png": 40205,
	"./Assets/vec1.png": 1872,
	"./Assets/vec2.png": 27719,
	"./Assets/vec3.png": 57747,
	"./Assets/vec5.png": 33603,
	"./Assets/vec6.png": 73763,
	"./Assets/vec7.png": 75314,
	"./Assets/vic1.png": 8834,
	"./Assets/vic2.png": 76582,
	"./Assets/vic3.png": 89112,
	"./Assets/vic4.png": 3858,
	"./Assets/woman-pressing-phone.jfif": 47129,
	"./Assets/x36.png": 2669,
	"./Assets/Сoding.png": 11278,
	"./Components": 28829,
	"./Components/": 28829,
	"./Components/Bundle": 71990,
	"./Components/Bundle/": 71990,
	"./Components/Bundle/index": 71990,
	"./Components/Bundle/index.jsx": 71990,
	"./Components/Charts": 38990,
	"./Components/Charts.jsx": 38990,
	"./Components/Converter": 57664,
	"./Components/Converter.jsx": 57664,
	"./Components/Dashboard": 48691,
	"./Components/Dashboard.jsx": 48691,
	"./Components/DefaultHeader": 40263,
	"./Components/DefaultHeader.js": 40263,
	"./Components/Documentation": 45313,
	"./Components/Documentation.jsx": 45313,
	"./Components/ErrorPage": 36594,
	"./Components/ErrorPage.jsx": 36594,
	"./Components/Faqs": 1048,
	"./Components/Faqs.jsx": 1048,
	"./Components/Footer": 69229,
	"./Components/Footer.jsx": 69229,
	"./Components/Header": 4615,
	"./Components/Header.jsx": 4615,
	"./Components/LoadMore": 93223,
	"./Components/LoadMore.jsx": 93223,
	"./Components/Notification": 83727,
	"./Components/Notification.jsx": 83727,
	"./Components/Products": 84240,
	"./Components/Products/": 84240,
	"./Components/Products/AirtimePin": 69375,
	"./Components/Products/AirtimePin.jsx": 69375,
	"./Components/Products/airtime": 59763,
	"./Components/Products/airtime.js": 59763,
	"./Components/Products/data": 81050,
	"./Components/Products/data-pin": 20435,
	"./Components/Products/data-pin.js": 20435,
	"./Components/Products/data.js": 81050,
	"./Components/Products/education": 24613,
	"./Components/Products/education.jsx": 24613,
	"./Components/Products/electricity-bills": 17782,
	"./Components/Products/electricity-bills.js": 17782,
	"./Components/Products/index": 84240,
	"./Components/Products/index.jsx": 84240,
	"./Components/Products/tv-subscriptions": 3190,
	"./Components/Products/tv-subscriptions.js": 3190,
	"./Components/Referral": 87398,
	"./Components/Referral.js": 87398,
	"./Components/Settings": 14750,
	"./Components/Settings.jsx": 14750,
	"./Components/Sidebar": 18297,
	"./Components/Sidebar.jsx": 18297,
	"./Components/Transactions": 12634,
	"./Components/Transactions/": 12634,
	"./Components/Transactions/index": 12634,
	"./Components/Transactions/index.jsx": 12634,
	"./Components/Users": 82472,
	"./Components/Users/": 82472,
	"./Components/Users/index": 82472,
	"./Components/Users/index.jsx": 82472,
	"./Components/Wallets": 47116,
	"./Components/Wallets/": 47116,
	"./Components/Wallets/index": 47116,
	"./Components/Wallets/index.jsx": 47116,
	"./Components/app-logo": 80914,
	"./Components/app-logo.jsx": 80914,
	"./Components/home-eight/HomeEightCard": 6258,
	"./Components/home-eight/HomeEightCard.jsx": 6258,
	"./Components/home-eight/HomeEightNav": 48035,
	"./Components/home-eight/HomeEightNav.jsx": 48035,
	"./Components/home-eighteen/FooterSection": 96008,
	"./Components/home-eighteen/FooterSection.jsx": 96008,
	"./Components/home-eighteen/ReviewSection": 46073,
	"./Components/home-eighteen/ReviewSection.jsx": 46073,
	"./Components/home-eighteen/benefits/BenefitSection": 1178,
	"./Components/home-eighteen/benefits/BenefitSection.jsx": 1178,
	"./Components/home-eighteen/contact/ContactSection": 86521,
	"./Components/home-eighteen/contact/ContactSection.jsx": 86521,
	"./Components/home-eighteen/hero/HeroSection": 95278,
	"./Components/home-eighteen/hero/HeroSection.jsx": 95278,
	"./Components/home-eighteen/service/ServiceSection": 52419,
	"./Components/home-eighteen/service/ServiceSection.jsx": 52419,
	"./Components/home-eleven/HomeElevenNav": 31389,
	"./Components/home-eleven/HomeElevenNav.jsx": 31389,
	"./Components/home-fifteen/HomeFifteenNav": 93587,
	"./Components/home-fifteen/HomeFifteenNav.jsx": 93587,
	"./Components/home-five/HomeFiveNav": 50231,
	"./Components/home-five/HomeFiveNav.jsx": 50231,
	"./Components/home-five/HomefiveCard": 95088,
	"./Components/home-five/HomefiveCard.jsx": 95088,
	"./Components/home-footer/home-footer": 5786,
	"./Components/home-footer/home-footer.jsx": 5786,
	"./Components/home-footer/home-footer.style.css": 34429,
	"./Components/home-four/Card": 6307,
	"./Components/home-four/Card.jsx": 6307,
	"./Components/home-four/home-four-btn": 57285,
	"./Components/home-four/home-four-btn.jsx": 57285,
	"./Components/home-four/home-four-nav": 22161,
	"./Components/home-four/home-four-nav.jsx": 22161,
	"./Components/home-fourteen/HomeFourteenNav": 99388,
	"./Components/home-fourteen/HomeFourteenNav.jsx": 99388,
	"./Components/home-nine/HomeNineCard": 48946,
	"./Components/home-nine/HomeNineCard.jsx": 48946,
	"./Components/home-nine/HomeNineNav": 69246,
	"./Components/home-nine/HomeNineNav.jsx": 69246,
	"./Components/home-ninteen/HomeNinteenNav": 83524,
	"./Components/home-ninteen/HomeNinteenNav.jsx": 83524,
	"./Components/home-one/home-one-nav.component": 75172,
	"./Components/home-one/home-one-nav.component.jsx": 75172,
	"./Components/home-seven/HomeSevenCard": 44064,
	"./Components/home-seven/HomeSevenCard.jsx": 44064,
	"./Components/home-seven/HomeSevenNav": 36539,
	"./Components/home-seven/HomeSevenNav.jsx": 36539,
	"./Components/home-seventeen/benefits/benefits": 62692,
	"./Components/home-seventeen/benefits/benefits.jsx": 62692,
	"./Components/home-seventeen/button/button": 33653,
	"./Components/home-seventeen/button/button.jsx": 33653,
	"./Components/home-seventeen/card/card": 92268,
	"./Components/home-seventeen/card/card.jsx": 92268,
	"./Components/home-seventeen/navigation/navigation": 27652,
	"./Components/home-seventeen/navigation/navigation.jsx": 27652,
	"./Components/home-six/HomeSixCard": 9607,
	"./Components/home-six/HomeSixCard.jsx": 9607,
	"./Components/home-six/HomeSixNav": 29555,
	"./Components/home-six/HomeSixNav.jsx": 29555,
	"./Components/home-sixteen/HomeSixteenCard": 53244,
	"./Components/home-sixteen/HomeSixteenCard.jsx": 53244,
	"./Components/home-sixteen/HomeSixteenNavigation": 75529,
	"./Components/home-sixteen/HomeSixteenNavigation.jsx": 75529,
	"./Components/home-sixteen/data": 88409,
	"./Components/home-sixteen/data.js": 88409,
	"./Components/home-subscription/home-subscription.style": 26753,
	"./Components/home-subscription/home-subscription.style.jsx": 26753,
	"./Components/home-ten/HomeTenCard": 55663,
	"./Components/home-ten/HomeTenCard.jsx": 55663,
	"./Components/home-ten/HomeTenNav": 59218,
	"./Components/home-ten/HomeTenNav.jsx": 59218,
	"./Components/home-tewntyone/HomeTwentyoneNav": 99974,
	"./Components/home-tewntyone/HomeTwentyoneNav.jsx": 99974,
	"./Components/home-thirteen/HomeThirteenNav": 2501,
	"./Components/home-thirteen/HomeThirteenNav.jsx": 2501,
	"./Components/home-three/home-three-nav": 78862,
	"./Components/home-three/home-three-nav.jsx": 78862,
	"./Components/home-three/service-card": 78779,
	"./Components/home-three/service-card.jsx": 78779,
	"./Components/home-twelve/HomeTwelveNav": 44835,
	"./Components/home-twelve/HomeTwelveNav.jsx": 44835,
	"./Components/home-twenty/HomeTwentyNav": 79178,
	"./Components/home-twenty/HomeTwentyNav.jsx": 79178,
	"./Components/index": 28829,
	"./Components/index.js": 28829,
	"./Data/Actions/ActionTypes": 72781,
	"./Data/Actions/ActionTypes.js": 72781,
	"./Data/Actions/AuthActions": 42493,
	"./Data/Actions/AuthActions.js": 42493,
	"./Data/Actions/GeneralAction": 51826,
	"./Data/Actions/GeneralAction.js": 51826,
	"./Data/Actions/UserActions": 62603,
	"./Data/Actions/UserActions.js": 62603,
	"./Data/Config": 1669,
	"./Data/Config.js": 1669,
	"./Data/Context": 86466,
	"./Data/Context.js": 86466,
	"./Data/Reducer": 61634,
	"./Data/Reducer/": 61634,
	"./Data/Reducer/AirtimeReducer": 4840,
	"./Data/Reducer/AirtimeReducer.js": 4840,
	"./Data/Reducer/AuthReducer": 87841,
	"./Data/Reducer/AuthReducer.js": 87841,
	"./Data/Reducer/CableReducer": 43772,
	"./Data/Reducer/CableReducer.js": 43772,
	"./Data/Reducer/DataReducer": 95328,
	"./Data/Reducer/DataReducer.js": 95328,
	"./Data/Reducer/EducationReducer": 37894,
	"./Data/Reducer/EducationReducer.js": 37894,
	"./Data/Reducer/ElectricityReducer": 94578,
	"./Data/Reducer/ElectricityReducer.js": 94578,
	"./Data/Reducer/ErrorReducer": 7202,
	"./Data/Reducer/ErrorReducer.js": 7202,
	"./Data/Reducer/GeneralReducer": 58469,
	"./Data/Reducer/GeneralReducer.js": 58469,
	"./Data/Reducer/ManualReducer": 89429,
	"./Data/Reducer/ManualReducer.js": 89429,
	"./Data/Reducer/SettingsReducer": 16540,
	"./Data/Reducer/SettingsReducer.js": 16540,
	"./Data/Reducer/StatReducer": 81369,
	"./Data/Reducer/StatReducer.js": 81369,
	"./Data/Reducer/UseCaseReducer": 59141,
	"./Data/Reducer/UseCaseReducer.js": 59141,
	"./Data/Reducer/UserReducer": 27760,
	"./Data/Reducer/UserReducer.js": 27760,
	"./Data/Reducer/WalletReducer": 88319,
	"./Data/Reducer/WalletReducer.js": 88319,
	"./Data/Reducer/index": 61634,
	"./Data/Reducer/index.js": 61634,
	"./Data/Store": 50066,
	"./Data/Store.js": 50066,
	"./Data/reviews": 29509,
	"./Data/reviews.jsx": 29509,
	"./Data/useFetch": 4031,
	"./Data/useFetch.js": 4031,
	"./PageRender": 77839,
	"./PageRender.jsx": 77839,
	"./Pages/bundles": 20075,
	"./Pages/bundles.jsx": 20075,
	"./Pages/converter": 26664,
	"./Pages/converter.jsx": 26664,
	"./Pages/dashboard": 36904,
	"./Pages/dashboard.jsx": 36904,
	"./Pages/documentation": 35361,
	"./Pages/documentation.jsx": 35361,
	"./Pages/faqs": 63965,
	"./Pages/faqs.jsx": 63965,
	"./Pages/home": 34030,
	"./Pages/home.jsx": 34030,
	"./Pages/notifications": 97243,
	"./Pages/notifications.jsx": 97243,
	"./Pages/products": 87822,
	"./Pages/products/": 87822,
	"./Pages/products/airtime": 48136,
	"./Pages/products/airtime.js": 48136,
	"./Pages/products/airtime_pin": 30816,
	"./Pages/products/airtime_pin.jsx": 30816,
	"./Pages/products/data": 54233,
	"./Pages/products/data-pin": 39387,
	"./Pages/products/data-pin.js": 39387,
	"./Pages/products/data.js": 54233,
	"./Pages/products/education": 58926,
	"./Pages/products/education.jsx": 58926,
	"./Pages/products/electricity-bills": 12544,
	"./Pages/products/electricity-bills.js": 12544,
	"./Pages/products/index": 87822,
	"./Pages/products/index.jsx": 87822,
	"./Pages/products/tv-subscriptions": 98034,
	"./Pages/products/tv-subscriptions.js": 98034,
	"./Pages/settings": 29195,
	"./Pages/settings.jsx": 29195,
	"./Pages/transactions": 56433,
	"./Pages/transactions/": 56433,
	"./Pages/transactions/index": 56433,
	"./Pages/transactions/index.jsx": 56433,
	"./Pages/wallets/bonus": 25465,
	"./Pages/wallets/bonus.jsx": 25465,
	"./Pages/wallets/commissions": 46767,
	"./Pages/wallets/commissions.jsx": 46767,
	"./Pages/wallets/my-wallet": 50365,
	"./Pages/wallets/my-wallet.jsx": 50365,
	"./Pages/wallets/referral": 90353,
	"./Pages/wallets/referral.jsx": 90353,
	"./Pages/wallets/referral/": 94953,
	"./Pages/wallets/referral/index": 94953,
	"./Pages/wallets/referral/index.jsx": 94953,
	"./Routes": 65227,
	"./Routes.jsx": 65227,
	"./Screens/about": 96426,
	"./Screens/about/": 96426,
	"./Screens/about/index": 96426,
	"./Screens/about/index.jsx": 96426,
	"./Screens/activate": 94551,
	"./Screens/activate.jsx": 94551,
	"./Screens/blogs": 5040,
	"./Screens/blogs/": 5040,
	"./Screens/blogs/index": 5040,
	"./Screens/blogs/index.jsx": 5040,
	"./Screens/contact": 8369,
	"./Screens/contact/": 8369,
	"./Screens/contact/index": 8369,
	"./Screens/contact/index.jsx": 8369,
	"./Screens/forget-password": 98533,
	"./Screens/forget-password.jsx": 98533,
	"./Screens/home": 55255,
	"./Screens/home-eight": 33245,
	"./Screens/home-eight/": 33245,
	"./Screens/home-eight/index": 33245,
	"./Screens/home-eight/index.jsx": 33245,
	"./Screens/home-eighteen": 37595,
	"./Screens/home-eighteen/": 37595,
	"./Screens/home-eighteen/index": 37595,
	"./Screens/home-eighteen/index.jsx": 37595,
	"./Screens/home-eleven": 95178,
	"./Screens/home-eleven/": 95178,
	"./Screens/home-eleven/index": 95178,
	"./Screens/home-eleven/index.jsx": 95178,
	"./Screens/home-fifteen": 58181,
	"./Screens/home-fifteen/": 58181,
	"./Screens/home-fifteen/index": 58181,
	"./Screens/home-fifteen/index.jsx": 58181,
	"./Screens/home-five": 3368,
	"./Screens/home-five/": 3368,
	"./Screens/home-five/Homefive.css": 48630,
	"./Screens/home-five/index": 3368,
	"./Screens/home-five/index.jsx": 3368,
	"./Screens/home-five/style.css": 66558,
	"./Screens/home-four": 56129,
	"./Screens/home-four/": 56129,
	"./Screens/home-four/index": 56129,
	"./Screens/home-four/index.jsx": 56129,
	"./Screens/home-fourteen": 42144,
	"./Screens/home-fourteen/": 42144,
	"./Screens/home-fourteen/index": 42144,
	"./Screens/home-fourteen/index.jsx": 42144,
	"./Screens/home-nine": 63438,
	"./Screens/home-nine/": 63438,
	"./Screens/home-nine/index": 63438,
	"./Screens/home-nine/index.jsx": 63438,
	"./Screens/home-ninteen": 2256,
	"./Screens/home-ninteen/": 2256,
	"./Screens/home-ninteen/index": 2256,
	"./Screens/home-ninteen/index.jsx": 2256,
	"./Screens/home-one": 12035,
	"./Screens/home-one/": 12035,
	"./Screens/home-one/home-one.style.css": 16459,
	"./Screens/home-one/index": 12035,
	"./Screens/home-one/index.jsx": 12035,
	"./Screens/home-seven": 70160,
	"./Screens/home-seven/": 70160,
	"./Screens/home-seven/index": 70160,
	"./Screens/home-seven/index.jsx": 70160,
	"./Screens/home-seventeen": 74293,
	"./Screens/home-seventeen/": 74293,
	"./Screens/home-seventeen/index": 74293,
	"./Screens/home-seventeen/index.jsx": 74293,
	"./Screens/home-six": 51505,
	"./Screens/home-six/": 51505,
	"./Screens/home-six/index": 51505,
	"./Screens/home-six/index.jsx": 51505,
	"./Screens/home-sixteen": 94106,
	"./Screens/home-sixteen/": 94106,
	"./Screens/home-sixteen/index": 94106,
	"./Screens/home-sixteen/index.jsx": 94106,
	"./Screens/home-ten": 85448,
	"./Screens/home-ten/": 85448,
	"./Screens/home-ten/index": 85448,
	"./Screens/home-ten/index.jsx": 85448,
	"./Screens/home-thirteen": 69931,
	"./Screens/home-thirteen/": 69931,
	"./Screens/home-thirteen/index": 69931,
	"./Screens/home-thirteen/index.jsx": 69931,
	"./Screens/home-three": 36472,
	"./Screens/home-three/": 36472,
	"./Screens/home-three/index": 36472,
	"./Screens/home-three/index.jsx": 36472,
	"./Screens/home-twelve": 5121,
	"./Screens/home-twelve/": 5121,
	"./Screens/home-twelve/index": 5121,
	"./Screens/home-twelve/index.jsx": 5121,
	"./Screens/home-twenty": 92412,
	"./Screens/home-twenty/": 92412,
	"./Screens/home-twenty/index": 92412,
	"./Screens/home-twenty/index.jsx": 92412,
	"./Screens/home-twentyone": 85208,
	"./Screens/home-twentyone/": 85208,
	"./Screens/home-twentyone/index": 85208,
	"./Screens/home-twentyone/index.jsx": 85208,
	"./Screens/home-two": 5892,
	"./Screens/home-two/": 5892,
	"./Screens/home-two/home-two.style.css": 68616,
	"./Screens/home-two/index": 5892,
	"./Screens/home-two/index.jsx": 5892,
	"./Screens/home.jsx": 55255,
	"./Screens/login": 82215,
	"./Screens/login.jsx": 82215,
	"./Screens/register": 222,
	"./Screens/register.jsx": 222,
	"./Screens/reset-activities": 15254,
	"./Screens/reset-activities.jsx": 15254,
	"./Screens/services": 46117,
	"./Screens/services/": 46117,
	"./Screens/services/index": 46117,
	"./Screens/services/index.jsx": 46117,
	"./Styles/Sidebar.css": 64788,
	"./Utils": 5023,
	"./Utils/": 5023,
	"./Utils/classnames": 9267,
	"./Utils/classnames.jsx": 9267,
	"./Utils/framer-motion/motion": 38323,
	"./Utils/framer-motion/motion.js": 38323,
	"./Utils/index": 5023,
	"./Utils/index.jsx": 5023,
	"./Views/administration": 62090,
	"./Views/administration/": 62090,
	"./Views/administration/admins": 75119,
	"./Views/administration/admins.jsx": 75119,
	"./Views/administration/employees": 85767,
	"./Views/administration/employees.jsx": 85767,
	"./Views/administration/index": 62090,
	"./Views/administration/index.jsx": 62090,
	"./Views/bundles": 22046,
	"./Views/bundles.jsx": 22046,
	"./Views/controls": 85988,
	"./Views/controls/": 85988,
	"./Views/controls/bonus": 92715,
	"./Views/controls/bonus.jsx": 92715,
	"./Views/controls/broadcasts": 95628,
	"./Views/controls/broadcasts.jsx": 95628,
	"./Views/controls/index": 85988,
	"./Views/controls/index.jsx": 85988,
	"./Views/controls/manual": 3493,
	"./Views/controls/manual.jsx": 3493,
	"./Views/controls/tv-subscriptions": 56961,
	"./Views/controls/tv-subscriptions.jsx": 56961,
	"./Views/converter": 17510,
	"./Views/converter.jsx": 17510,
	"./Views/dashboard": 1043,
	"./Views/dashboard.jsx": 1043,
	"./Views/documentation": 60548,
	"./Views/documentation.jsx": 60548,
	"./Views/faqs": 7724,
	"./Views/faqs.jsx": 7724,
	"./Views/home": 242,
	"./Views/home.jsx": 242,
	"./Views/notifications": 36013,
	"./Views/notifications.jsx": 36013,
	"./Views/products": 79144,
	"./Views/products/": 79144,
	"./Views/products/airtime": 52611,
	"./Views/products/airtime.js": 52611,
	"./Views/products/airtime_pin": 3414,
	"./Views/products/airtime_pin.jsx": 3414,
	"./Views/products/data": 27953,
	"./Views/products/data-pin": 19212,
	"./Views/products/data-pin.js": 19212,
	"./Views/products/data.js": 27953,
	"./Views/products/education": 31554,
	"./Views/products/education.jsx": 31554,
	"./Views/products/electricity-bills": 99457,
	"./Views/products/electricity-bills.js": 99457,
	"./Views/products/index": 79144,
	"./Views/products/index.jsx": 79144,
	"./Views/products/tv-subscriptions": 28089,
	"./Views/products/tv-subscriptions.js": 28089,
	"./Views/reports": 78215,
	"./Views/reports/": 78215,
	"./Views/reports/index": 78215,
	"./Views/reports/index.jsx": 78215,
	"./Views/settings": 29020,
	"./Views/settings.jsx": 29020,
	"./Views/transactions": 78027,
	"./Views/transactions/": 78027,
	"./Views/transactions/add": 9224,
	"./Views/transactions/add.jsx": 9224,
	"./Views/transactions/index": 78027,
	"./Views/transactions/index.jsx": 78027,
	"./Views/users": 43241,
	"./Views/users/": 43241,
	"./Views/users/index": 43241,
	"./Views/users/index.jsx": 43241,
	"./Views/users/profile/[id]": 3434,
	"./Views/users/profile/[id].jsx": 3434,
	"./Views/users/purchase/[id]": 59869,
	"./Views/users/purchase/[id].jsx": 59869,
	"./Views/users/upgrade": 69464,
	"./Views/users/upgrade.jsx": 69464,
	"./Views/users/wallet/[id]": 87938,
	"./Views/users/wallet/[id].jsx": 87938,
	"./Views/wallets": 85735,
	"./Views/wallets/": 85735,
	"./Views/wallets/bonus": 51488,
	"./Views/wallets/bonus-data": 59845,
	"./Views/wallets/bonus-data.jsx": 59845,
	"./Views/wallets/bonus.jsx": 51488,
	"./Views/wallets/commissions": 33043,
	"./Views/wallets/commissions.jsx": 33043,
	"./Views/wallets/find-transactions": 48817,
	"./Views/wallets/find-transactions.jsx": 48817,
	"./Views/wallets/give-bonus": 55554,
	"./Views/wallets/give-bonus.jsx": 55554,
	"./Views/wallets/index": 85735,
	"./Views/wallets/index.jsx": 85735,
	"./Views/wallets/manage-transactions": 27158,
	"./Views/wallets/manage-transactions.jsx": 27158,
	"./Views/wallets/manual": 18117,
	"./Views/wallets/manual.jsx": 18117,
	"./Views/wallets/my-wallet": 14319,
	"./Views/wallets/my-wallet.jsx": 14319,
	"./Views/wallets/provider": 30096,
	"./Views/wallets/provider.jsx": 30096,
	"./Views/wallets/referral": 5012,
	"./Views/wallets/referral.jsx": 5012,
	"./Views/wallets/referral/": 64454,
	"./Views/wallets/referral/[id]": 75709,
	"./Views/wallets/referral/[id].jsx": 75709,
	"./Views/wallets/referral/index": 64454,
	"./Views/wallets/referral/index.jsx": 64454,
	"./Views/wallets/wallet-funding": 84335,
	"./Views/wallets/wallet-funding/": 84335,
	"./Views/wallets/wallet-funding/[id]": 40833,
	"./Views/wallets/wallet-funding/[id].jsx": 40833,
	"./Views/wallets/wallet-funding/index": 84335,
	"./Views/wallets/wallet-funding/index.jsx": 84335,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;